import React, { Component } from 'react';

class ChartPadding extends Component {
    render() { 
        return (  
            <div className="pre-footer-padding"></div>
        );
    }
}
 
export default ChartPadding;